import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/ProjectCategoryController/CreateProjectCategoryController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateProjectCategory({ category, onClose, onSuccess, ProjectList }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ ID: 0, ProjectID: 0, CategoryName: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [UserList, setUserList] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    useEffect(() => {
        if (category) {
            setFormData({
                ID: category.ProjectCategoriesID,
                ProjectID: category.ProjectID,
                CategoryName: category.CategoryName
            });
            setErrors({});
        } else {
            setFormData({ ID: 0, ProjectID: 0, CategoryName: '' }); // Clear form data when switching to add mode
            setErrors({});
        }
    }, [category, ProjectList]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (category) {
            formData.ID = category.ProjectCategoriesID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };

        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="projectCategoryModal" tabIndex="-1" aria-labelledby="projectCategoryModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="assetSubCategoriesModalLabel">{category ? "Edit Category" : "Add Category"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="ProjectID" className="col-sm-2 col-form-label">Select Project:</label>
                                    <div className="col-sm-4">
                                        <select name="ProjectID" className='form-control' value={formData.ProjectID} onChange={handleFieldChange}>
                                            <option value="0">Select Project</option>
                                            {ProjectList.map((project) => (
                                                <option key={project.ID} value={project.ID}>
                                                    {project.ProjectName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.ProjectID && <div style={{ color: 'red' }}>{errors.ProjectID}</div>}
                                    </div>
                                    <label htmlFor="CategoryName" className="col-sm-2 col-form-label">Category:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="CategoryName" value={formData.CategoryName} onChange={handleFieldChange} />
                                        {errors.CategoryName && <div style={{ color: 'red' }}>{errors.CategoryName}</div>}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true">  {category ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateProjectCategory;
